// META-ELVÁLASZTÓ PONT — két, EGY GONDOLATOT mondó adat között a fejléc meta-soraiban.
//
// MIÉRT KÜLÖN KOMPONENS: a belső jegy-részlet ÉS a partner-portál jegy-részlete ugyanezt a tagolást
// használja („ki nyitotta · mikor"), és a szabály is közös: a CSOPORTOK között TÉRKÖZ tagol, pont CSAK a
// csoporton BELÜL. Két példányban a pont tónusa (`text-subtle`) csendben elcsúszott volna.
//
// `aria-hidden`: tisztán vizuális — a képernyőolvasó a két adatot amúgy is külön mondja.
export function MetaDot(): JSX.Element {
  return (
    <span className="text-subtle" aria-hidden="true">
      ·
    </span>
  );
}
